import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobileMenuButton", "mobileMenu"]
  connect() {
    this.beforeCache = () => this.closeMenu()
    document.addEventListener("turbo:before-cache", this.beforeCache)
  }
  disconnect() { document.removeEventListener("turbo:before-cache", this.beforeCache) }
  toggleMenu() {
    const open = this.mobileMenuTarget.classList.toggle("is-open")
    this.mobileMenuButtonTarget.setAttribute("aria-expanded", String(open))
    this.mobileMenuButtonTarget.textContent = open ? "CLOSE −" : "MENU +"
  }
  closeMenu() {
    this.mobileMenuTarget.classList.remove("is-open")
    this.mobileMenuButtonTarget.setAttribute("aria-expanded", "false")
    this.mobileMenuButtonTarget.textContent = "MENU +"
  }
}
